<template>
  <div class="page">
    <header>
      <div v-html="header"></div>
    </header>

    <div class="page-body">
      <div v-for="(el, key2) in body"
           :key="key2"
           class="page-block"
           v-html="el">
      </div>
    </div>

    <footer>
      <div v-html="footer"></div>
      <div class="page-number"> </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'document-page',
  props: {
    header: {
      type: String,
      default() {
        return ''
      }
    },
    body: {
      type: Array,
      default() {
        return []
      }
    },
    footer: {
      type: String,
      default() {
        return ''
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// DocumentPage.vue?f8c541ee